export default __webpack_public_path__ + "static/media/acer.a6ed9c25.jpg";